import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowRight, Clock, Tag } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { getIcon } from "@/lib/icons";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";

export default function ServiceDetail() {
  const { slug } = useParams();
  const { t, lang, pickL } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setS(false)); }, [slug]);
  if (s === null) return <div className="container-x py-24 text-muted-foreground">{t("common.loading")}</div>;
  if (s === false) return <div className="container-x py-24">Not found</div>;
  const feats = pickL(s, "features") || [];
  return (
    <div>
      <Seo title={pickL(s, "name")} description={pickL(s, "short")} image={s.cover_image || undefined}
        jsonLd={{ "@context": "https://schema.org", "@type": "Service", name: pickL(s, "name"), description: pickL(s, "short"), provider: { "@type": "Organization", name: "JonuzovicDesign" }, offers: { "@type": "Offer", price: s.starting_price, priceCurrency: "EUR" } }} />
      <PageHero eyebrow={s.category} title={pickL(s, "name")} subtitle={pickL(s, "short")}>
        <div className="mt-6 flex flex-wrap gap-4 text-sm">
          <span className="inline-flex items-center gap-2 rounded-md border border-border px-4 py-2"><Tag size={15} className="text-primary" /> {t("common.from")} <b>{s.starting_price}€</b></span>
          <span className="inline-flex items-center gap-2 rounded-md border border-border px-4 py-2"><Clock size={15} className="text-primary" /> {s.delivery_time}</span>
        </div>
      </PageHero>
      <section className="container-x py-14 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary/10 text-primary mb-6">{getIcon(s.icon, { size: 26 })}</div>
          <p className="text-lg leading-relaxed text-muted-foreground">{pickL(s, "desc")}</p>
          <h3 className="font-display font-bold text-xl mt-10 mb-4">{lang === "de" ? "Leistungsmerkmale" : "Features"}</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {feats.map((f, i) => (
              <div key={i} className="flex items-start gap-2.5 surface p-4"><Check size={18} className="text-primary shrink-0 mt-0.5" /> <span className="text-sm">{f}</span></div>
            ))}
          </div>
          {s.technologies?.length > 0 && (
            <>
              <h3 className="font-display font-bold text-xl mt-10 mb-4">{lang === "de" ? "Technologien" : "Technologies"}</h3>
              <div className="flex flex-wrap gap-2">{s.technologies.map((tech) => <span key={tech} className="rounded-full border border-border px-4 py-1.5 text-sm">{tech}</span>)}</div>
            </>
          )}
        </div>
        <aside>
          <div className="surface p-7 sticky top-24">
            <div className="font-display text-3xl font-black">{s.starting_price}€</div>
            <p className="text-sm text-muted-foreground mt-1 mb-6">{lang === "de" ? "Startpreis, projektabhängig." : "Starting price, project dependent."}</p>
            <Link to="/quote" className="btn-primary w-full mb-3" data-testid="service-quote-btn">{t("hero.cta1")} <ArrowRight size={16} /></Link>
            <Link to="/contact" className="btn-ghost w-full" data-testid="service-contact-btn">{t("nav.contact")}</Link>
          </div>
        </aside>
      </section>
    </div>
  );
}
